export default __webpack_public_path__ + "static/media/profilepic.721d7575.svg";